import React from 'react';
import { twMerge } from 'tailwind-merge';

interface InitialsProps {
  content: string;
}

const Initials = ({ content }: InitialsProps) => {
  const initialsClassName = twMerge(
    'bg-kira-blue-100',
    'text-kira-slate-800',
    'rounded-full',
    'h-9',
    'w-9',
    'flex',
    'justify-center',
    'items-center',
    'prose-title-h5'
  );

  return <div className={initialsClassName}>{content ?? ''}</div>;
};

export default Initials;
